import React, { useEffect, useState ,useContext  } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const ClientDetail = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [expandedAccounts, setExpandedAccounts] = useState({});
  const [file, setFile] = useState(null);
  const { registeredUser } = useContext(AuthContext); // contains loginId

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/clients/${clientId}`);
        setClient(res.data);
      } catch (err) {
        console.error('Failed to fetch client data:', err);
        navigate('/advisor-dashboard');
      }
    };
    fetchDetails();
  }, [clientId, navigate]);

  const toggleExpand = (credId) => {
    setExpandedAccounts(prev => ({
      ...prev,
      [credId]: !prev[credId]
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type !== 'text/csv' && !selectedFile.name.endsWith('.csv')) {
        alert('Only CSV files are allowed.');
        e.target.value = '';
        return;
    }
    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file || !registeredUser?.loginId) {
      alert('Missing file or login session');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('clientId', clientId);
    formData.append('uploadedBy', registeredUser.loginId); // matches logindetails.login_id

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/upload-trade`, formData);
      alert(res.data.message || 'Upload successful');
      setFile(null);
    } catch (err) {
      console.error('Upload error:', err);
      alert('Upload failed');
    }
  };

  if (!client) return <p>Loading client details...</p>;

  return (
    <div className="client-details">
        <div className="client-info-sticky">
            <h2>Client Info</h2>
            <p><strong>Name:</strong> {client.client.full_name}</p>
            <p><strong>Email:</strong> {client.client.email}</p>
            <p><strong>Phone:</strong> {client.client.phone}</p>
        </div>
        
      {/* Upload Section */}
      <div className="upload-section" style={{ marginTop: '20px' }}>
        <h3>Upload Trade File</h3>
        <input type="file" onChange={handleFileChange} />
        <button onClick={handleUpload} disabled={!file}>
          Upload Trade Document
        </button>
      </div>

      <div className="custodian-section">
        <h3>Custodian Accounts</h3>
        {client.custodians.map((custodian, i) => (
          <div key={i} className="custodian-card">
            <div style={{
              background: '#ECE4F4',
              padding: '12px 16px',
              fontWeight: 'bold',
              color: '#6A0DAD'
            }}>
              {custodian.custodian_name}
            </div>

            {custodian.accounts.map(account => (
              <div key={account.client_cred_id}>
                <div
                  onClick={() => toggleExpand(account.client_cred_id)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    background: '#f8f8f8',
                    padding: '10px 14px',
                    cursor: 'pointer'
                  }}
                >
                  <div>Account: {account.account_number}</div>
                  <div>{expandedAccounts[account.client_cred_id] ? '▲' : '▼'}</div>
                </div>

                {expandedAccounts[account.client_cred_id] && account.details && (
                  <div className="custodian-details">
                    <p><strong>Account Type:</strong> {account.details.holding_type}</p>
                    <p><strong>Account Value:</strong> {account.details.account_value}</p>
                    <p><strong>Total Portfolio:</strong> {account.details.total_portfolio_value}</p>
                    <p><strong>Last Action:</strong> {account.details.last_action_date}</p>
                    <p><strong>Details as on :</strong> {account.details.scrape_timestamp}</p>

                    <h4>Holdings</h4>
                    {account.details.holdings && account.details.holdings.length > 0 ? (
                      <table>
                        <thead>
                          <tr>
                            <th>Symbol</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Qty</th>
                            <th>Total Value</th>
                            <th>Gain</th>
                          </tr>
                        </thead>
                        <tbody>
                          {account.details.holdings.map((h, i) => (
                            <tr key={i}>
                              <td>{h.symbol}</td>
                              <td>{h.description}</td>
                              <td>{h.current_price}</td>
                              <td>{h.quantity}</td>
                              <td>{h.total_value}</td>
                              <td>{h.total_gain}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No holdings data available.</p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

      <button onClick={() => navigate('/trader-dashboard')}>
        ← Back to Dashboard
      </button>
    </div>
  );
};

export default ClientDetail;
